
import { MHTTPCL, JSON_STRING, HttpClient, createHttpGetOptions, jsonToFormData } from "../../../services/http/http-client";
import { CONTACTS_URL, LABEL_URL,SETTINGS_URL,TASK_URL } from "../../../services/common-urls";

export const taskService = {

    //https://dev.berlin3.com/updatecheck2/tasks.pl?section=general_task&action=task_list

    taskList:(status='open,pending,question',assigned_users,start,end)=>MHTTPCL.get(TASK_URL,{
        section:'general_task',
        action:'task_list',
        status:status,
        assigned_user_id:assigned_users,
        start:start,
        end:end,
        output:JSON_STRING
    }),
    taskListSearch:(search="",row_start=0,row_count=100,chapter="",sent_user="",start="",end="",status="",assigned_users="")=>MHTTPCL.post(TASK_URL,{
        section:'general_task',
        action:'task_list',
        row_start:row_start,
        row_count:row_count,
        search:	search,
        chapter:chapter,
        start:start,
        end:end,
        sent_user_id:sent_user,
        status:status,
        assigned_user_id:assigned_users,
        output:JSON_STRING
    }),

    taskListAdvanceSearch:(search="",chapter="",sent_user="",start="",end="",status="",row_start=0,row_count=100)=>MHTTPCL.post(TASK_URL,{
        section:'general_task',
        action:'task_list',
        row_start:row_start,
        row_count:row_count,
        search:	search,
        chapter:chapter,
        start:start,
        end:end,
        sent_user:sent_user,
        status:status,
        output:JSON_STRING
    }),

    taskTemplateGroup:(external_table)=>MHTTPCL.post(TASK_URL,{
        section:'settings',
        action:'task_template_group',
        external_table:external_table,
        output:JSON_STRING
    }).then(res=>{
        console.log(res,"TORES")
        return {
            data:{
                [`${external_table}_task_template_groups`]:res.data.task_template_groups,
                [`${external_table}_task_templates`]:res.data.task_templates,

            }
        }
    }),
    taskTemplateGroupAddUpdate:(task_group_name,external_table)=>MHTTPCL.post(SETTINGS_URL,{
        section	:"bsettings",
        action	:"task_template_group_add_update",
        task_group_name:task_group_name,
        external_table:external_table,
        output:JSON_STRING
    }),

    getTaskTemplatesOfGroup: (task_group_id,external_table) => HttpClient.get(SETTINGS_URL, {
        section: 'bsettings',
        action: 'task_templates_of_group',
        task_group_id
    }).then(res=>{
        console.log(res,"TORES23")
        return {
            data:{
                [`${external_table}_task_templates_of_group`]:res.data.task_templates_of_group,

            }
        }
    }),

    deleteBookingTaskTemplateGroup: (task_group_id) => HttpClient.post(SETTINGS_URL, {
        section: 'bsettings',
        action: 'task_template_group_delete',
        task_group_id:task_group_id,
        output:JSON_STRING
    }),



    addUpdateTaskTemplate: (taskTemplate,extra_fields) => HttpClient.post(SETTINGS_URL, {
        section: 'bsettings',
        action: 'task_template_add_update',
        ...taskTemplate,
        json_data:JSON.stringify(extra_fields)
    }),

    taskTemplateDelete:(task_template_id)=>MHTTPCL.post(SETTINGS_URL,{
        section : 'bsettings',
        action : 'task_template_delete',
        task_template_id:task_template_id,
        output:JSON_STRING

    }),

    



    tasksTab:()=>MHTTPCL.get(TASK_URL,{
        section:'general_task',
        action:'tasks_tab',
        output:JSON_STRING
    }),

    //task create

    addTaskUser:(task)=>MHTTPCL.post(TASK_URL,{
        section:'general_task',
        action:'add_task_user',
        ...task,
       
    }),

    

    

    


    //tasks.pl?section=settings&action=task_template_group&external_table=booking
}
